import React from "react";
import { GoogleMap, DirectionsRenderer } from "@react-google-maps/api";
import { PRICE_PER_KM } from '../data/mock';

const MapRoute = ({ origin, destination, onDistanceChange, onPriceChange }) => {
  const [directions, setDirections] = React.useState(null);

  React.useEffect(() => {
    if (!origin || !destination) return;

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK || status === "OK") {
          setDirections(result);

          const totalDistanceMeters = result.routes[0].legs.reduce(
            (sum, leg) => sum + leg.distance.value,
            0
          );
          const km = totalDistanceMeters / 1000;
          const price = km * PRICE_PER_KM;

          if (onDistanceChange) onDistanceChange(km);
          if (onPriceChange) onPriceChange(price);
        } else {
          console.error("error fetching directions", result);
        }
      }
    );
  }, [origin, destination, onDistanceChange, onPriceChange]);

  if (!origin || !destination) return null;

  return (
    <div className="mt-4 h-80 w-full rounded-lg overflow-hidden">
      <GoogleMap
        mapContainerStyle={{ width: "100%", height: "100%" }}
        center={{ lat: 43.7102, lng: 7.2620 }}
        zoom={11}
      >
        {directions && <DirectionsRenderer directions={directions} />}
      </GoogleMap>
    </div>
  );
};

export default MapRoute;
